import styled from "styled-components";

type ContainerProps = {
  $grow?: boolean;
  $width?: string;
  $height?: string;
};

export const Container = styled.div<ContainerProps>`
  ${({ $grow, $width, $height }) =>
    $grow
      ? `
    flex: 1;
  `
      : `
      height: ${$height};
      width: ${$width};
      `}
`;
